import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import styles from "./modal.module.css";
import ReactHtmlParser from "react-html-parser";
import { AiOutlineClose } from "react-icons/ai";

export default function NewWords({ newWords, hiddenWords }) {
  const [openModal, setOpenModal] = React.useState(false);
  const toggle = () => setOpenModal(!openModal);
  return (
    <>
      <div>
        <Button
          type="button"
          color="info"
          onClick={toggle}
          hidden={newWords && newWords.length > 0 ? false : true}
          disabled={newWords && newWords.length > 0 ? false : true}
          style={{
            cursor: newWords && newWords.length > 0 ? "pointer" : "no-drop",
          }}
        >
          Tra cứu
        </Button>
        <div>
          <Modal
            isOpen={openModal}
            toggle={toggle}
            className={`${styles.modalDialog} ${styles.guideModal}`}
            backdrop={false}
          >
            <ModalHeader className={`${styles.modalHeader}`}>
              {newWords?.[0]?.title}

              <AiOutlineClose
                size={35}
                onClick={toggle}
                className={`${styles.spanX}`}
              />
            </ModalHeader>
            <ModalBody>{ReactHtmlParser(newWords?.[0]?.description)}</ModalBody>
            <ModalFooter>
              <Button color="info" onClick={toggle}>
                Đóng
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    </>
  );
}
